<ng-container *ngIf="(transferCounts$ | async) && (job$ | async) as job">
  <div
    class="transfer-info"
    matTooltipPosition="above"
    matTooltip="Transferiert / Total mögliche Transfers">
    <mat-icon
      class="transfer-info-icon pending-transfers-icon"
      svgIcon="board-mission-transfer-waiting-clock"></mat-icon>
    <div
      class="transfer-count"
      data-cy="job-transfer-info-count">
      {{ (transferCounts$ | async)?.transferred
      }}<span class="transfer-info-slash">/</span
      >{{ (transferCounts$ | async)?.total }}
    </div>
  </div>
  <div
    class="transfer-info"
    matTooltipPosition="above"
    matTooltip="abgelehnte Transfers">
    <mat-icon
      class="transfer-info-icon declined-transfers-icon"
      svgIcon="board-mission-transfer-decline-rejected"></mat-icon>
    {{ (transferCounts$ | async)?.declined }}
  </div>
  <div
    *ngIf="job.status === jobStatusEnum.OPEN"
    class="transfer-info">
    <div
      class="tooltip-sub-wrapper"
      matTooltipPosition="above"
      matTooltip="aktive automatische Transfers">
      <mat-icon
        class="transfer-info-icon auto-transfers-icon"
        svgIcon="board-mission-transfer-auto-star"></mat-icon>
      {{ (transferCounts$ | async)?.auto }}
    </div>
    <ng-container
      *ngIf="(transferCounts$ | async)?.nextAutoTransfer as nextAutoTransfer"
      ><span class="transfer-info-slash">/</span
      >{{
        "nextTransferAt"
          | i18n
            : {
                date: nextAutoTransfer * 1000 | date: "dd.MM.yyyy"
              }
      }}
      ({{
        nextAutoTransfer * 1000 | convertToDateObject | formatDistance
      }})</ng-container
    >
  </div>
</ng-container>
